<template>
    <el-dialog :title="(type == 'completed' ? '已' : '未') + '考核人员'" :visible.sync="dialogVisible" :close-on-click-modal="false"
        width="80rem">
        <div class="content-box" v-if="tableList.length > 0">
            <div class="thead">
                <div>序号</div>
                <div>姓名</div>
                <div>所属班级</div>
                <div>账号</div>
            </div>
            <div v-for="(item, index) in tableList" :class="(index % 2 == 0) ? 'single' : 'twin'" class="tbody-item"
                :key="index">
                <div>{{ '0' + (index + 1) }}</div>
                <text-overflow :content="item.userName"></text-overflow>
                <!-- <el-tooltip effect="dark" :content="item.userName" placement="top-start">
                    <div class="overflow">{{ item.userName }}</div>
                </el-tooltip> -->
                <text-overflow :content="item.className"></text-overflow>
                <!-- <el-tooltip effect="dark" :content="item.className" placement="top-start">
                    <div class="overflow">{{ item.className }}</div>
                </el-tooltip> -->
                <text-overflow :content="item.loginName"></text-overflow>
                <!-- <el-tooltip effect="dark" :content="item.loginName" placement="top-start">
                    <div class="overflow">{{ item.loginName }}</div>
                </el-tooltip> -->
            </div>
        </div>
        <no-data style="height: 50rem;" v-else></no-data>
    </el-dialog>
</template>

<script>
import { GetExamineUserInfo } from '@/api/examine';
import NoData from '../../../common/NoData.vue';
import TextOverflow from '../../../common/TextOverflow.vue';
export default {
    components: { NoData, TextOverflow },
    data() {
        return {
            dialogVisible: false,
            type: '',
            /**列表数据 */
            tableList: [
                {
                    name: '张三',
                    class: '初一二班',
                    account: '15623681610'
                },
                {
                    name: '张三',
                    class: '初一二班',
                    account: '15623681610'
                }
            ],
            pages: {
                current: 1,
                size: 10,
                total: 0,
            }
        }
    },
    methods: {
        /**分页查询(已考-未考)用户信息 */
        getExamineUserInfo(examId, type) {
            let params = {
                "current": this.pages.current,
                "examId": examId,
                "size": this.pages.size,
                "isExam": type,
            }
            GetExamineUserInfo(params).then(res => {
                this.tableList = res.data.records;
                this.pages.total = res.data.total;
                this.dialogVisible = true;
            })
        },
    }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__title {
    font-size: 16px;
    font-weight: 700;
}

.thead {
    height: 4.8rem;
    background-color: #ECF3FF;
    display: flex;
    align-items: center;
    color: #334681;
    font-weight: 700;
    padding: 0 3.5rem;

    &> :nth-child(n) {
        flex: 1;
    }

    &> :nth-child(3) {
        flex: 1.5;
    }
}

.tbody-item {
    height: 4.8rem;
    display: flex;
    align-items: center;
    color: #334681;
    font-weight: 700;
    padding: 0 3.5rem;

    &> :nth-child(n) {
        flex: 1;
    }

    &> :nth-child(3) {
        flex: 1.5;
    }
}

.single {
    background-color: rgba(236, 243, 255, 0.20);
}

.twin {
    background-color: #ECF3FF;
}

/deep/.el-dialog__body {
    padding: 0 3rem 5rem 3rem;
}

/deep/.el-dialog__header {
    padding: 3rem 5rem;
}

/deep/.el-dialog {
    border-radius: 16px;
}

/deep/.el-dialog__headerbtn {
    top: 1rem;
    right: 14px;
    color: #8590B3;
}

.content-box {
    height: 50rem;
    overflow: auto;
}
</style>